import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { RoleEntity, AuthenticationEntity } from "./entities";
import { CommonResponse } from "@boi/shared-models";

@Injectable()
export class RolesService {
    private roleRepository: Repository<RoleEntity>;
    private authRepository: Repository<AuthenticationEntity>;

    constructor(private dataSource: DataSource) {
        this.roleRepository = this.dataSource.getRepository(RoleEntity);
        this.authRepository = this.dataSource.getRepository(AuthenticationEntity);
    }

    async createRole(role: Partial<RoleEntity>): Promise<CommonResponse> {
        try {
            const newRole = await this.roleRepository.save(role);
            return new CommonResponse(true, 200, "Role created successfully", newRole);
        } catch (error) {
            return new CommonResponse(false, 500, "Error creating role", error.message);
        }
    }

    async updateRole(id: number, role: Partial<RoleEntity>): Promise<CommonResponse> {
        try {
            await this.roleRepository.update(id, role);
            return new CommonResponse(true, 200, "Role updated successfully");
        } catch (error) {
            return new CommonResponse(false, 500, "Error updating role", error.message);
        }
    }

    async deleteRole(id: number): Promise<CommonResponse> {
        try {
            await this.roleRepository.delete(id);
            return new CommonResponse(true, 200, "Role deleted successfully");
        } catch (error) {
            return new CommonResponse(false, 500, "Error deleting role", error.message);
        }
    }

    async getRoles(): Promise<CommonResponse> {
        try {
            const roles = await this.roleRepository.find();
            return new CommonResponse(true, 200, "Roles fetched successfully", roles);
        } catch (error) {
            return new CommonResponse(false, 500, "Error fetching roles", error.message);
        }
    }

    async getRoleById(id: number): Promise<CommonResponse> {
        try {
            const role = await this.roleRepository.findOne({ where: { id } });
            return new CommonResponse(true, 200, "Role fetched successfully", role);
        } catch (error) {
            return new CommonResponse(false, 500, "Error fetching role", error.message);
        }
    }

    async assignRoleToUser(userId: number, roleId: number): Promise<CommonResponse> {
        try {
            await this.authRepository.update(userId, { roleId });
            return new CommonResponse(true, 200, "Role assigned successfully");
        } catch (error) {
            return new CommonResponse(false, 500, "Error assigning role", error.message);
        }
    }
}
